export const NotFoundComponentMixin = defineNuxtComponent({
  props: {
    title: {
      required: false,
      type: String,
      default: 'Page Not Found',
    },

    description: {
      required: false,
      type: String,
      default: 'The page you are looking for doesn&#x27;t exist or has been moved',
    },

    isFullScreenError: {
      required: false,
      default: false,
      type: Boolean,
    },

    backgroundColor: {
      required: false,
      type: String,
    },
  },
});
